import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const PaymentAPI = {
  getAll: function ({ org_id, limit, offset }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/payments`,
      params: { limit, offset },
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    })
  },
  getById: function (org_id, payment_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/payments/${org_id}/${payment_id}`,
    })
  },
  create: function ({ org_id, files, period_start, period_end, amount, order_set, paid, exported }) {
    let formData = new FormData()
    files.forEach(f => {
      formData.append('files', f)
    })
    formData.append('period_start', period_start)
    formData.append('period_end', period_end)
    formData.append('amount', amount)
    formData.append('paid', paid)
    formData.append('exported', exported)
    if (order_set) {
      formData.append('order_set', order_set)
    }
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/payments`,
      data: formData,
    })
  },
  update: function ({
    org_id,
    payment_id,
    files,
    period_start,
    period_end,
    amount,
    order_set,
    paid,
    exported,
    delete_files,
  }) {
    let formData = new FormData()
    files.forEach(f => {
      formData.append('files', f)
    })
    formData.append('period_start', period_start)
    formData.append('period_end', period_end)
    formData.append('amount', amount)
    formData.append('paid', paid)
    formData.append('exported', exported)
    formData.append('delete_files', delete_files)
    if (order_set) {
      formData.append('order_set', order_set)
    }
    return axiosInstance.request({
      method: 'PUT',
      url: `/payments/${org_id}/${payment_id}`,
      data: formData,
    })
  },
  delete: function (org_id, payment_id) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/payments/${org_id}/${payment_id}`,
    })
  },
}

const cancelTokenObject = createCancelToken(PaymentAPI)
export default PaymentAPI
